"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 *
 * Remove widows from an html string.
 *
 * First the function parses the html using a regex for content between <tag></tag>
 * Then it breaks that into words and counts the length of the string in words
 * Then it counts the length of the last three words and applies either
 * a three word widow break if the words are small enough
 * or a two word widow break if the words are longer
 * but only if the total string length is at least the minimum number of words
 *
 * @param {*} html the html
 * @param {object} [config={
    minWords: 4,
    maxLastWordLength: 9,
    maxPenultWordLength: 4,
    maxAntepenultWordLength: 5,
    maxLastWordLengthTwo: 13,
    maxPenultWordLengthTwo: 11,
  }] the config object
 * @returns
 */


var unWidowerTextOnly = function unWidowerTextOnly(html, config) {
  if (typeof html !== "undefined") {
    var defaultConfig = {
      minWords: 4,
      maxLastWordLength: 9,
      // defaults for three-word widow breaker
      maxPenultWordLength: 4,
      // defaults for three-word widow breaker
      maxAntepenultWordLength: 5,
      // defaults for two-word widow-breaker
      maxLastWordLengthTwo: 13,
      // defaults for two-word widow-breaker
      maxPenultWordLengthTwo: 11
    }; // merge passed config with default

    var _defaultConfig$config = _objectSpread({}, defaultConfig, {}, config),
        minWords = _defaultConfig$config.minWords,
        maxLastWordLength = _defaultConfig$config.maxLastWordLength,
        maxPenultWordLength = _defaultConfig$config.maxPenultWordLength,
        maxAntepenultWordLength = _defaultConfig$config.maxAntepenultWordLength,
        maxLastWordLengthTwo = _defaultConfig$config.maxLastWordLengthTwo,
        maxPenultWordLengthTwo = _defaultConfig$config.maxPenultWordLengthTwo;

    var processedText = html; // match all text strings inside html

    var regex = new RegExp("(?<=>)(?!<).*?(?=<)", "g");
    var matches = html.replace(/(\(|\)|\\|\/|\.)/g, "").match(regex);

    if (matches != null) {
      matches.map(function (string) {
        var newstring;
        var splitstring = string.split(" ");

        if (splitstring.length >= minWords) {
          var lastword = splitstring[splitstring.length - 1];
          var penultword = splitstring[splitstring.length - 2];
          var antepenultword = splitstring[splitstring.length - 3];

          if (lastword.length <= maxLastWordLength && penultword.length <= maxPenultWordLength && antepenultword.length <= maxAntepenultWordLength) {
            // replace last two breaking spaces with nbsps
            newstring = string.replace(/ (?=[^ ]*$)/i, "\xA0").replace(/ (?=[^ ]*$)/i, "\xA0");
          } else if (lastword.length <= maxLastWordLengthTwo && penultword.length <= maxPenultWordLengthTwo) {
            // replace last breaking space with a nbsp
            newstring = string.replace(/ (?=[^ ]*$)/i, "\xA0");
          }

          var stringMatch = new RegExp("(?<=>)(?!<)".concat(string, "(?=</)"), "g");
          processedText = processedText.replace(stringMatch, newstring);
          return newstring;
        }

        return null;
      });
      return processedText;
    }
  }

  return html;
};

var _default = unWidowerTextOnly;
exports["default"] = _default;